import { USE_MOCKS } from '@/lib/mocks';
import { authContainer } from '@/modules/auth/di/container';
import { SubmissionApiDatasource } from '../data/datasources/submission-api.datasource';
import { SubmissionMockDatasource } from '../data/datasources/submission-mock.datasource';
import { SubmissionRepositoryImpl } from '../data/repositories/submission.repository.impl';

/**
 * No mock, o dono do envio vem da sessão simulada; na API ele vem do token,
 * e o datasource não precisa saber quem é.
 */
const datasource = USE_MOCKS
  ? new SubmissionMockDatasource(
      () => authContainer.currentUserId(),
      () => authContainer.currentUserHasProfile(),
    )
  : new SubmissionApiDatasource();

export const submissionContainer = {
  repository: new SubmissionRepositoryImpl(datasource),
};
